import { MANDATORY } from 'redux/domain/Settings/constants';

// Checks that the field was not left blank if the specified fieldSettings mark it as mandatory
const settingValidation = fieldSettings => value =>
	fieldSettings.fieldStatus === MANDATORY && !value ? 'Required' : undefined;

export default settingValidation;
